import { render, staticRenderFns } from "./ChatSelector.vue?vue&type=template&id=7993cd3c&scoped=true"
import script from "./ChatSelector.vue?vue&type=script&lang=js"
export * from "./ChatSelector.vue?vue&type=script&lang=js"
import style0 from "./ChatSelector.vue?vue&type=style&index=0&id=7993cd3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993cd3c",
  null
  
)

export default component.exports